import type {Asset} from '@hconnect/common'
import {FC} from 'react'

import {useEditGrindingCircuit} from '../../hooks/grindingCircuits'
import {GrindingCircuit, GrindingCircuitPayload} from '../../types'

import {GrindingCircuitsFormDialog} from './GrindingCircuitsFormDialog'

import {useUrlParam} from '@settings/modules/routing'

type GrindingCircuitsEditProps = {
  assets?: Asset[]
  defaultValues?: GrindingCircuit
  isDialogOpen: boolean
  setIsDialogOpen: (isOpen: boolean) => void
}

export const GrindingCircuitsEdit: FC<GrindingCircuitsEditProps> = ({
  assets,
  setIsDialogOpen,
  isDialogOpen,
  defaultValues
}) => {
  const plantCode = useUrlParam('plantCode')
  const {mutate: updateGrindingUnit, isPending} = useEditGrindingCircuit(() =>
    setIsDialogOpen(false)
  )

  const handleEdit = (data: GrindingCircuitPayload) => {
    if (!defaultValues) return
    updateGrindingUnit({plantCode, grindingCircuitDto: {...data, id: defaultValues.id}})
  }

  return (
    <>
      {isDialogOpen && (
        <GrindingCircuitsFormDialog
          isEdit
          onSubmit={handleEdit}
          defaultValues={defaultValues}
          isLoading={isPending}
          assets={assets}
          onClose={() => setIsDialogOpen(false)}
        />
      )}
    </>
  )
}
